import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿La consulta es privada?',
    answer: 'Sí, toda información es completamente confidencial.'
  }, {
    question: '¿Atiendes online?',
    answer: 'Sí, dependiendo del servicio solicitado.'
  }, {
    question: '¿Necesito conocimientos previos?',
    answer: 'No, cualquier persona puede acceder a la consulta.'
  }, {
    question: '¿Atiendes en Antofagasta?',
    answer: 'Sí, previa coordinación.'
  }, {
    question: '¿Cómo solicito una consulta?',
    answer: 'Simplemente haciendo clic en cualquiera de los botones de WhatsApp.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-54">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-55">
            Preguntas <span className="text-gradient-gold" data-id="element-56">frecuentes</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-57">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-panel rounded-xl overflow-hidden" data-id="element-58">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-59">
                <span className="font-medium text-mystic-white/90 pr-4" data-id="element-60">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-mystic-gold shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-61" />
              </button>

              <AnimatePresence data-id="element-62">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-63">
                    <div className="px-6 pb-5 text-mystic-white/70 font-light border-t border-mystic-gold/10 pt-4" data-id="element-64">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}